import React, { useMemo } from 'react';
import {
  Center,
  HStack,
  VStack,
  Text,
  Button,
  Skeleton,
  Box
} from '@chakra-ui/react';
import { TbCoins } from 'react-icons/tb';
import { formatUSD } from '@app/helpers/formatUSD';
import { useToggle } from 'react-use';
import { MarketMakerWidgetModal } from '@app/screens/positions/components/MarketMakerWidget/MarketMakerWidgetModal';
import { useMarketMakerTokensDetails } from '@app/hooks/merkl/useMarketMakerTokensDetails';
import { useMetromMarketMakerTokensDetails } from '@app/hooks/metrom/useMetromMarketMakerTokensDetails';

export const MarketMakerWidget = () => {
  const [open, toggleOpen] = useToggle(false);

  const { totalUSD, tokensSymbols, userRewards } =
    useMarketMakerTokensDetails();

  const { totalUSD: metromRewardsUsd, userRewards: metromUserRewards } =
    useMetromMarketMakerTokensDetails();

  const totalUsdValue = useMemo(() => {
    return (totalUSD ?? 0) + (metromRewardsUsd ?? 0);
  }, [totalUSD, metromRewardsUsd]);

  return (
    <>
      <HStack
        py="12px"
        px="12px"
        borderRadius="8px"
        bg="gray.3"
        minWidth="240px"
        border="1px solid"
        borderColor="whiteOpacity.6"
        gap={4}
        width={['100%', 'fit-content']}
      >
        <Center
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            background: 'neutral.800'
          }}
        >
          <TbCoins size="24" color="#eed202" />
        </Center>
        <VStack alignItems="flex-start" justifyContent="center">
          <Text
            fontSize={16}
            fontWeight={500}
            color="neutral.300"
            lineHeight={1}
          >
            Market Maker
          </Text>
          {totalUsdValue ? (
            <Text fontSize={20} fontWeight={500} lineHeight={1}>
              {formatUSD.format(totalUsdValue ?? 0)}
            </Text>
          ) : (
            <Box height="20px">&nbsp;</Box>
          )}
        </VStack>
        <Button variant="row" ml={12} onClick={toggleOpen}>
          Harvest
        </Button>
      </HStack>
      <MarketMakerWidgetModal
        isOpen={open}
        onClose={toggleOpen}
        merklData={userRewards}
        metromData={metromUserRewards}
        totalValue={totalUSD ?? 0}
      />
    </>
  );
};
